import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextInput from '../../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import Celebrate from './Celebrate';
import PersonalForm from './PersonalForm';

import * as PersonalDataActions from './actions';
import PartnerForm from './PartnerForm';
import CommonUtil from '../../../../../../utils/commonUtil';
import commonUtil from '../../../../../../utils/commonUtil';
import * as defaultConst from "../../../../../../utils/clientConstant";
import Warning from '../../../../../../components/Warning';
const { getEventDetails, updateOwnerDetails, addCoOwnerDetails } = PersonalDataActions;
import { eventType } from '../../../../../../utils/clientConstant';
import Warning2 from '../../../../../../components/Warning2';
import { loadGiftRegistryCelebrated } from '../../../../../createEvent/components/GiftRegistryCelebrated/actions';

 const channel = commonUtil.getChannel();

@connect(store => ({
    store,
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
}),
    {
        ...PersonalDataActions,
        loadGiftRegistryCelebrated
    })

class PersonalData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Initialize your state here if needed
            mydata: {},
            ownerData: {},
            personalData: {},
            partnerData: {},
            celebrityData: {},
            bodaData:{},
            disableSubmit: true,
            celebrate1FirstName: '',
            celebrate2FirstName: '',
            initailPartnerPhone: '',
            eventTypefromData: null,
            typeAlert: "",
            disablePersoalSubmit: false,
            ownerIsCelebrity: false,
            emailErrorCelebrity: '',
            celebrityFormEmailError: '',
            canAddCelebrity: 'false',
            canAddCoOwner: 'false',
        };
        this.refs = {
            firstName: React.createRef(),
            lastName: React.createRef(),
            phone: React.createRef(),
            password: React.createRef(),
        };
    }

    actualizarDatos = {
        id: 'updateData',
        type: 'button',
        name: 'Actualizar datos',
        value: 'Actualizar datos',
        classname: 'btn btn-default',
        onClickHandler: () => {
            // Handle clear filter action
            // console.log('update personal data clicked');
        },
        disabled: false,
        autoFocus: false,
        ariaLabel: 'update personal data',
        ariaHidden: false,
        cssStyle: {
            width: '100%',
            padding: '16px',
            backgroundColor: '#D8D8D8',
            borderRadius: '4px'
        },
    };

    _getEventDetails = (eventID) => {
        const { user, eventId, profileId } = this.props;
        // console.log(user)
        //update the user to dynamic
        this.props.getEventDetails(eventId, profileId).then((data) => {              
            let ownerData = [];
            let coOwnerData = [];
            let celebrityData = [];
            let ownerIsCelebrityData = [];
            let ownerIsCelebrity = false;
            const userCount = data?.eventDetailsInfo?.celebrityInfo?.length || 0;
            const arrayofEventType = [eventType.Cumpleanos , eventType.Other_Religious_Ceremonies,eventType.Open_House,eventType.Others];
            ownerData = data.eventDetailsInfo.celebrityInfo
                ? data.eventDetailsInfo.celebrityInfo.filter(
                    info => info.isCelebrity === false && info.iscoOwner == "false"
                )
                : [];
            coOwnerData = data.eventDetailsInfo.celebrityInfo
                ? data.eventDetailsInfo.celebrityInfo.filter(
                    info =>  info.iscoOwner == "true"
                )
                : [];
            celebrityData = data.eventDetailsInfo.celebrityInfo
                ? data.eventDetailsInfo.celebrityInfo.filter(
                    info => info.isCelebrity === true && ((data?.eventDetailsInfo.eventType == eventType.Boda) ? (info.iscoOwner == "false") : true)
                )
                : [];

            let bodaData = data.eventDetailsInfo.celebrityInfo
                ? data.eventDetailsInfo.celebrityInfo.filter(
                    info => info.isCelebrity === true && info.iscoOwner == "true"
                )
                : [];
            //below scenario checks if owner is also celebrity
            ownerIsCelebrityData = data.eventDetailsInfo.celebrityInfo
                ? data.eventDetailsInfo.celebrityInfo.filter(
                    info => 
                            info.isCelebrity === true &&  
                            info.iscoOwner == "false" &&
                            info.primaryOwner == "true"
                )
                : [];
            //if ownerIsCelebrityData length is equal to 1  means owner is also celebrity
            // if ownerIsCelebrityData length is more than 1 means there are separate owner and celebrity
            if (ownerIsCelebrityData.length === 1 && arrayofEventType.includes(data?.eventDetailsInfo.eventType)) {                
                ownerIsCelebrity = true;
            }
         
            this.setState({
                mydata: data,
                personalData: ownerData &&  ownerData[0] || ownerIsCelebrityData[0] || {},
                partnerData: coOwnerData && coOwnerData[0] || {},
                celebrityData:celebrityData && celebrityData[0] || {},
                bodaData: bodaData && bodaData[0] || {},
                ownerIsCelebrity: ownerIsCelebrity,
                // initialPersonaPhone: data.eventDetailsInfo.celebrityInfo[0].phone,
                // initailPartnerPhone:data.eventDetailsInfo.celebrityInfo[1].phone,
                eventTypefromData: data?.eventDetailsInfo.eventType || '',
                celebrate1FirstName: data?.eventDetailsInfo?.celeb1firstName || '',
                celebrate2FirstName: data?.eventDetailsInfo?.celeb2firstName || "",
                canAddCelebrity: data?.eventDetailsInfo?.canAddCelebrity || 'false',
                canAddCoOwner: data?.eventDetailsInfo?.canAddCoOwner || 'false',
            })
        });
    }


    componentDidMount() {
        this._getEventDetails();
    }

    // onchangePartnerHandler = (e) => {
    //     const { name, value } = e.target; 
    //     this.setState((prevState) => ({
    //         partnerData: {
    //             ...prevState.partnerData, // Spread previous formData
    //             [name]: value, // Update only the specific field
    //         }
    //     }));
    // }

    enableSubmitButton = (val) => {
        this.setState({
            disableSubmit: val
        })
    }

  updateOwnerDetails = async (owner, formName) => {
    const { profileId, eventId, eventType, lables } = this.props;

    try {
      if (owner?.ownerHasPermission) {
        if (owner?.ownerEmail === this.state?.personalData?.email) {
          this.setState({
            [formName === 'celebrityForm'
              ? 'celebrityFormEmailError'
              : 'emailErrorCelebrity']: commonUtil.getLabel(
              lables?.createEventStep1,
              'error.duplicate.owner.email',
            ),
          });
          return;
        }
        const celebRes = await loadGiftRegistryCelebrated(
          owner?.ownerEmail,
          eventType,
        );

        if (celebRes?.body?.status?.status !== 'success') {
          return;
        }

        owner.profileId = celebRes?.body?.profileId;
      }
 
      const res = await updateOwnerDetails(owner, profileId, eventId);

      const status = res?.body?.status?.status;
      const errorMessage = res?.body?.status?.status?.errorMessage;

      if (status === defaultConst.constAPISuccess && !errorMessage) {
        this.setState({
          [formName === 'celebrityForm'
            ? 'celebrityFormEmailError'
            : 'emailErrorCelebrity']: ''
        });
        this.updateWarningState({
          message: commonUtil.getLabel(
            lables.EventAdminPage,
            `adminpage.update.owner.details.success${channel == 'web' ? '.web' : ''}`,
          ),
          type: 'success',
        });

        this._getEventDetails(eventId, profileId);
        return;
      }

      this.updateWarningState({
        message: errorMessage || 'Ocurrió un error',
        type: 'error',
      });
    } catch (e) {
      // console.log(e); // console required
      const errorMessage =
        e?.body?.detail ||
        commonUtil.getLabel(
          lables.EventAdminPage,
          'adminpage.verify.co-ownwer.email',
        );

      this.setState({
        [formName === 'celebrityForm'
          ? 'celebrityFormEmailError'
          : 'emailErrorCelebrity']: errorMessage
      });
    }
  };

  addCoOwnerDetails = async (owner) => {
    const { profileId, eventId, eventType, lables } = this.props;

    try {
      if (owner?.ownerHasPermission) {
        if (owner?.ownerEmail === this.state?.personalData?.email) {
          this.setState({
            emailErrorCelebrity: commonUtil.getLabel(
              lables?.createEventStep1,
              'error.duplicate.owner.email',
            ),
          });
          return;
        }
        const celebRes = await loadGiftRegistryCelebrated(
          owner?.ownerEmail,
          eventType,
        );

        if (celebRes?.body?.status?.status !== 'success') {
          return;
        }

        owner.profileId = celebRes?.body?.profileId;
      }

      const res = await addCoOwnerDetails(owner, profileId, eventId);

      const status = res?.body?.status?.status;
      const errorMessage = res?.body?.status?.status?.errorMessage;

      if (status === defaultConst.constAPISuccess && !errorMessage) {
        this.setState({ emailErrorCelebrity: '' });
        this.updateWarningState({
          message: commonUtil.getLabel(
            lables.EventAdminPage,
            'adminpage.add.coowner.details.success',
          ),
          type: 'success',
        });

        this._getEventDetails(eventId, profileId);
        return;
      }

      this.updateWarningState({
        message: errorMessage || 'Ocurrió un error',
        type: 'error',
      });
    } catch (e) {
      // console.log(e); // console required
     
      this.setState({
        emailErrorCelebrity: e?.body?.detail ? e?.body?.detail : commonUtil.getLabel(
          lables.EventAdminPage,
          'adminpage.verify.co-ownwer.email',
        ),
      });
    }
  };

    updateWarningState = ({ message, type, complementary = [''] }) => {
        this.setState({ ...this.state, typeAlert: type });
        this.alertMessage.setMessage(commonUtil.getLabel(
            this.props.lables.editEventDelivery,
            message,
            complementary,
        ));
    }

    setEmailErrorCelebrity = (value) => {
      this.setState({
        emailErrorCelebrity: value
      })
    }

    setCelebrityFormEmailError = (value) => {
      this.setState({
        celebrityFormEmailError: value
      })
    }

    render() {
        const { bodaData, celebrityData, personalData, partnerData, celebrate1FirstName, celebrate2FirstName, eventTypefromData, emailErrorCelebrity } = this.state;
        const { lables } = this.props

       

        return (
            <>
                <Warning2  
                    // onClose
                    style={{
                      marginBottom: 25,
                      ...(channel === 'web' && {
                        width: '688px',
                      }),
                       ...(channel === 'wap' && {
                          position: 'absolute',
                          top: '0px',
                          zIndex: 9999
                      })
                    }}
                    spanStyle={{ height: 'auto' }}
                    type={this.state.typeAlert}
                    ref={alertMessage => this.alertMessage = alertMessage}
                />
                <div className="personal-data-wrapper row">
                    <div className='personal-data-header'

                    >{commonUtil.getLabel(lables.EventAdminPage,'adminpage.verify.your.data')}</div>

                    <div style={{ display: 'flex' }} className='row personal-data-main'>
                        <div className="personal-data-container col-md-6 col-sm-12 col-xs-12">

                            {/* //   Festejado section starts here */}
                            { eventTypefromData != eventType.Boda &&
                                <Celebrate
                                    // celebrate1FirstName={celebrate1FirstName}
                                    // celebrate2FirstName={celebrate2FirstName}
                                    EventTypeProps={eventTypefromData}
                                    celebrityData={celebrityData}
                                    createcelebrateDetails={this.addCoOwnerDetails}
                                    updatecelebrateDetails={this.updateOwnerDetails}
                                    selectedTheme ={this.props.selectedTheme || {}}
                                    lables={this.props.lables}
                                    ownerIsCelebrity={this.state.ownerIsCelebrity}
                                    canAddCelebrity={this.state.canAddCelebrity}
                                    eventStatus={this.props.eventStatusInfo || ""}
                                    celebrityFormEmailError={this.state.celebrityFormEmailError}
                                    setCelebrityFormEmailError={this.setCelebrityFormEmailError}
                                    enableCelebrityUpdate={
                                      (this.state.mydata &&
                                        this.state.mydata.eventDetailsInfo &&
                                        this.state.mydata.eventDetailsInfo
                                          .enableCelebrityUpdate) ||
                                      false
                                    }
                                />}

                            {/* //   Festejado section ends here */}

                            {<PersonalForm
                                personalData={eventTypefromData != eventType.Boda ? personalData : celebrityData}
                                // onchangePersonalHandler ={(e)=>{this.onchangePersonalHandler(e)}} 
                                // phoneref={this.refs.phone}
                                updateOwnerDetails={this.updateOwnerDetails}
                                EventTypeProps={eventTypefromData}
                                selectedTheme ={this.props.selectedTheme || {}}
                                lables={this.props.lables}

                            />}
                            {/* Add your component content here */}
                        </div>
                        {<PartnerForm
                            partnerData={eventTypefromData != eventType.Boda ? partnerData : bodaData}
                            updateOwnerDetails={this.updateOwnerDetails}
                            createpartnerDetails={this.addCoOwnerDetails}
                            EventTypeProps={eventTypefromData}
                            selectedTheme ={this.props.selectedTheme || {}}
                            lables={this.props.lables}
                            emailErrorCelebrity = {emailErrorCelebrity}
                            setEmailErrorCelebrity={this.setEmailErrorCelebrity}
                            eventStatus={this.props.eventStatusInfo || ""}
                        />}
                    </div>


                </div>
            </>

        );
    }
}


const mapStateToProps = state => ({
    lables: state.labels.data,
    user: state.user.data,
    //   userEventDetails: state.eventDetails.userEventDetails,
    //   celebrityInfoData: state.eventDetails.userEventDetails.eventDetailsInfo.celebrityInfo,
    //   eventStatus: state.eventDetail.data.eventList,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getEventDetails, addCoOwnerDetails, updateOwnerDetails, loadGiftRegistryCelebrated }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(PersonalData); 